import {faExternalLink} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {useLocale} from '../../../../../../provider/locale/locale-hook';

import {faWaze} from './waze-icon';
import * as styles from './link-column.scss';

type PropsType = {
    link: string | null;
    wazeLink?: string | null;
};

export function LinkColumn(props: PropsType): JSX.Element | null {
    const {link, wazeLink} = props;
    const {getLocalizedString} = useLocale();

    const hasGoogleLink = Boolean(link && link.trim().length > 0);
    const hasWazeLink = Boolean(wazeLink && wazeLink.trim().length > 0);

    if (!hasGoogleLink && !hasWazeLink) {
        return null;
    }

    return (
        <span className={styles.LinkColumn}>
            {hasGoogleLink && link ? (
                <a href={link} rel="noreferrer" target="_blank">
                    <FontAwesomeIcon className={styles.LinkColumn_icon} icon={faExternalLink} />
                </a>
            ) : null}

            {hasWazeLink && wazeLink ? (
                <a
                    aria-label={getLocalizedString('SOURCES__TABLE__WAZE_LINK')}
                    href={wazeLink}
                    rel="noopener noreferrer"
                    target="_blank"
                    title={getLocalizedString('SOURCES__TABLE__WAZE_LINK')}
                >
                    <FontAwesomeIcon className={styles.LinkColumn_icon} icon={faWaze} />
                </a>
            ) : null}
        </span>
    );
}
